"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputHandler = void 0;
const KHInputKey_1 = require("./KHInputKey");
class KHInputHandler {
    constructor(scene, inputs, inputSet) {
        this.scene = scene;
        this.mappings = new Map();
        for (const key in inputs) {
            let val = inputs[key];
            if (val instanceof KHInputKey_1.KHInputKey) {
                val = [val];
            }
            this.mappings.set(key, val);
        }
        this.inputSet = inputSet;
    }
    register(registrar) {
        this.inputSet.registerWith(registrar);
    }
    unregister() {
        this.inputSet.unregister();
    }
    /**
     * Returns if key was pressed down this frame.
     */
    isJustDown(key) {
        if (!this.inputSet.registered()) {
            console.warn("Attempting to get inputs with unregistered input set. Call register first.");
        }
        let mappings = this.mappings.get(key);
        if (!mappings) {
            console.log("No mappings for " + key);
            return;
        }
        for (let i = 0; i < mappings.length; i++) {
            if (mappings[i].isJustDown())
                return true;
        }
        return false;
    }
    /**
     * Returns if key is currently down.
     */
    isDown(key) {
        if (!this.inputSet.registered()) {
            console.warn("Attempting to get inputs with unregistered input set. Call register first.");
        }
        let mappings = this.mappings.get(key);
        if (!mappings) {
            console.log("No mappings for " + key);
            return;
        }
        for (let i = 0; i < mappings.length; i++) {
            if (mappings[i].isDown())
                return true;
        }
        return false;
    }
}
exports.KHInputHandler = KHInputHandler;
